var _div, _div2;
import { Skeleton } from '@crehana/compass.ui/skeleton';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var StaticPoweredBy = function StaticPoweredBy() {
  return _div || (_div = /*#__PURE__*/_jsx("div", {
    className: "tw-w-full tw-flex tw-flex-col tw-justify-center tw-items-start tw-py-0.4 tw-px-2",
    children: /*#__PURE__*/_jsxs("p", {
      className: "tw-font-body5 tw-text-neutral-light-600 dark:tw-text-neutral-dark-400",
      children: ["Powered by ", /*#__PURE__*/_jsx("span", {
        className: "tw-font-semibold",
        children: "Crehana"
      })]
    })
  }));
};
export var GlobalSidebarSkeleton = function GlobalSidebarSkeleton() {
  return /*#__PURE__*/_jsx("div", {
    className: "tw-w-full tw-flex tw-flex-col tw-bg-neutral-light-200 dark:tw-bg-elevation-dark-00",
    style: {
      height: '100svh',
      maxHeight: '100svh'
    },
    children: _div2 || (_div2 = /*#__PURE__*/_jsxs("div", {
      className: "tw-flex tw-grow tw-overflow-hidden",
      children: [/*#__PURE__*/_jsx("div", {
        className: "group/sidebar-wrapper tw-h-full tw-flex tw-w-0 sm:tw-w-[11.2rem] lg:tw-w-[25.6rem] tw-relative",
        children: /*#__PURE__*/_jsxs("div", {
          className: "tw-group tw-h-full tw-w-full tw-flex tw-flex-col tw-border-r tw-border-solid tw-border-neutral-light-300 tw-bg-neutral-light-100",
          children: [/*#__PURE__*/_jsx("div", {
            className: "tw-relative tw-grow tw-overflow-y-auto",
            children: /*#__PURE__*/_jsxs("div", {
              className: "tw-flex tw-min-h-0 tw-flex-col tw-h-full tw-space-y-1.2 tw-pt-1.6 tw-overflow-y-auto tw-overflow-x-hidden tw-gap-1.6 tw-transition-all tw-duration-300 tw-bg-neutral-light-100",
              children: [/*#__PURE__*/_jsxs("div", {
                className: "tw-space-y-1",
                children: [/*#__PURE__*/_jsx("li", {
                  className: "tw-group/menu-item tw-list-none tw-pl-1.2 tw-pr-0.8",
                  children: /*#__PURE__*/_jsx(Skeleton, {
                    className: "tw-h-4 tw-w-full"
                  })
                }), /*#__PURE__*/_jsx("li", {
                  className: "tw-group/menu-item tw-list-none tw-pl-1.2 tw-pr-0.8",
                  children: /*#__PURE__*/_jsx(Skeleton, {
                    className: "tw-h-4 tw-w-full"
                  })
                })]
              }), /*#__PURE__*/_jsxs("div", {
                className: "tw-space-y-1.6",
                children: [/*#__PURE__*/_jsx("div", {
                  className: "tw-flex tw-h-3.2 tw-shrink-0 tw-items-center tw-px-2 tw-py-1.2 tw-font-label1 tw-text-neutral-dark-700 tw-transition-all tw-duration-200 tw-ease-linear",
                  children: /*#__PURE__*/_jsx(Skeleton, {
                    className: "tw-h-1.6 tw-w-16"
                  })
                }), /*#__PURE__*/_jsx("li", {
                  className: "tw-group/menu-item tw-list-none tw-pl-1.2 tw-pr-0.8",
                  children: /*#__PURE__*/_jsx(Skeleton, {
                    className: "tw-h-4 tw-w-full"
                  })
                }), /*#__PURE__*/_jsx("li", {
                  className: "tw-group/menu-item tw-list-none tw-pl-1.2 tw-pr-0.8",
                  children: /*#__PURE__*/_jsx(Skeleton, {
                    className: "tw-h-4 tw-w-full"
                  })
                }), /*#__PURE__*/_jsx("li", {
                  className: "tw-group/menu-item tw-list-none tw-pl-1.2 tw-pr-0.8",
                  children: /*#__PURE__*/_jsx(Skeleton, {
                    className: "tw-h-4 tw-w-full"
                  })
                }), /*#__PURE__*/_jsx("li", {
                  className: "tw-group/menu-item tw-list-none tw-pl-1.2 tw-pr-0.8",
                  children: /*#__PURE__*/_jsx(Skeleton, {
                    className: "tw-h-4 tw-w-full"
                  })
                }), /*#__PURE__*/_jsx("li", {
                  className: "tw-group/menu-item tw-list-none tw-pl-1.2 tw-pr-0.8",
                  children: /*#__PURE__*/_jsx(Skeleton, {
                    className: "tw-h-4 tw-w-full"
                  })
                }), /*#__PURE__*/_jsx("li", {
                  className: "tw-group/menu-item tw-list-none tw-pl-1.2 tw-pr-0.8",
                  children: /*#__PURE__*/_jsx(Skeleton, {
                    className: "tw-h-4 tw-w-full"
                  })
                })]
              })]
            })
          }), /*#__PURE__*/_jsxs("div", {
            className: "tw-min-h-0 tw-shrink-0 tw-flex tw-flex-col tw-border-t tw-border-solid tw-border-neutral-light-400",
            children: [/*#__PURE__*/_jsx("li", {
              className: "tw-group/menu-item tw-list-none tw-pl-1.2 tw-pr-0.8",
              children: /*#__PURE__*/_jsx(Skeleton, {
                className: "tw-h-4 tw-my-0.8 tw-w-full"
              })
            }), /*#__PURE__*/_jsx("div", {
              className: "tw-w-full tw-px-2 tw-py-1.2 tw-border-t tw-border-solid tw-border-neutral-light-400",
              children: /*#__PURE__*/_jsx(StaticPoweredBy, {})
            })]
          })]
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "tw-grow"
      })]
    }))
  });
};